import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = ({ variant = 'default' }) => {
  const bgColor = variant === 'business' ? 'bg-slate-900' : variant === 'loans' ? 'bg-slate-900' : 'bg-slate-900';
  const accentColor = variant === 'loans' ? 'text-green-400' : 'text-esh-blue-400';

  return (
    <footer className={`${bgColor} text-white py-12`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/Esh-Ham Main - Edited.png" 
                alt="Esh-Ham Logo" 
                className="h-12 w-auto object-contain drop-shadow-lg"
              />
              <span className="text-xl font-bold">Esh-Ham</span>
            </div>
            <p className="text-gray-300 italic mb-4 text-sm">
              Your trusted Namibian partner for professional Company Secretarial Services and accessible Personal Loans.
            </p>
            <div className="mt-4">
              <h5 className="font-semibold text-white">Esh-Ham Business Consultants</h5>
              <p className="text-sm text-gray-400">Registration number: cc/2011/1182</p>
              <h5 className="font-semibold text-white mt-2">Esh-Ham Cash Loans</h5>
              <p className="text-sm text-gray-400">NAMFISA license number: 25/11/921</p>
            </div>
          </div>
          
          {/* Contact Information */}
          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-center space-x-2">
                <Phone className={`w-4 h-4 ${accentColor}`} />
                <span className="text-gray-300">+264 61 306 369</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className={`w-4 h-4 ${accentColor}`} />
                <span className="text-gray-300">+264 81 424 7723</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className={`w-4 h-4 ${accentColor}`} />
                <span className="text-gray-300">info@eshham.com</span>
              </div>
            </div>
          </div>
          
          {/* Address */}
          <div>
            <h4 className="font-semibold mb-4">Location</h4>
            <div className="flex items-start space-x-2 text-sm">
              <MapPin className={`w-4 h-4 ${accentColor} mt-1 flex-shrink-0`} />
              <div className="text-gray-300">
                <p>Southern Industrial Area</p>
                <p>Armstrong Street</p>
                <p>Old Power Station, Office #36</p>
                <p>Windhoek, Namibia</p>
              </div>
            </div>
          </div>
          
          {/* Business Hours */}
          <div>
            <h4 className="font-semibold mb-4">Business Hours</h4>
            <div className="space-y-2 text-sm text-gray-300">
              <p>Monday - Friday</p>
              <p className="text-white font-medium">8:00 AM - 5:00 PM</p>
              <p className="mt-3">Saturday</p>
              <p className="text-white font-medium">9:00 AM - 1:00 PM</p>
              <p className="mt-3">Sunday: Closed</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; 2025 Esh-Ham. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
